export const getOperarioNombre = (operarioId, operarios) => {
  if (!operarioId) return 'N/A';
  const operario = operarios.find(op => op.id === operarioId);
  return operario ? operario.nombre : 'Desconocido';
};

export const formatDateTime = (isoString) => {
  if (!isoString) return 'N/A';
  const date = new Date(isoString);
  return date.toLocaleString('es-MX', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });
};

export const calculateElapsedTime = (startTimeIso, currentTime, totalTiempoPausadoMs) => {
  if (!startTimeIso) return 0;
  const start = new Date(startTimeIso).getTime();
  const current = currentTime.getTime();
  const activeTimeMs = Math.max(0, current - start - totalTiempoPausadoMs);
  return Math.floor(activeTimeMs / 1000); // Tiempo en segundos
};

export const formatDuration = (totalSeconds) => {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return `${hours}h ${minutes}m ${seconds}s`;
};

// Nueva función para verificar stock
export const checkStockAvailability = (consumos, allMaterials) => {
  if (!consumos || consumos.length === 0) {
    return { isStockOk: true, missingMaterials: [] }; // Si no hay consumos, se asume que hay stock
  }

  const missing = [];
  let allOk = true;

  for (const consumo of consumos) {
    const material = allMaterials.find(mat => mat.id === consumo.materialId);
    if (!material || material.stockActual < consumo.unidadesNecesarias) {
      allOk = false;
      missing.push({
        materialId: consumo.materialId,
        codigo: material ? material.codigo : 'Desconocido',
        descripcion: material ? material.descripcion : 'Material no encontrado',
        needed: consumo.unidadesNecesarias,
        available: material ? material.stockActual : 0,
      });
    }
  }
  return { isStockOk: allOk, missingMaterials: missing };
};

export const getMaterialInfo = (materialId, allMaterials) => {
  return allMaterials.find(mat => mat.id === materialId);
};